import { showSuccess, showError } from '@/utils/toastHelpers';
import { useCreateTshirtSize, useUpdateTshirtSize, useDeleteTshirtSize } from '@/hooks/useTshirtSizes';
import { useEntityActions } from '@/hooks/useEntityActions';

export const useTshirtSizesActions = (selectedRaceId: string, selectedRaceTypeId: string) => {
  const createSize = useCreateTshirtSize(selectedRaceId);
  const updateSize = useUpdateTshirtSize();
  const deleteSize = useDeleteTshirtSize();

  const crud = useEntityActions<any, { size: string; sortOrder: number; raceTypeId: string }>({
    emptyForm: { size: '', sortOrder: 0, raceTypeId: '' },
    deleteMutation: deleteSize,
    entityName: 'Големината',
  });

  const handleEdit = (size: any) => {
    crud.openEdit(size, (s: any) => ({
      size: s.size, sortOrder: s.sortOrder, raceTypeId: s.raceTypeId || '',
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!crud.formData.size.trim()) {
      showError({ message: 'Внесете големина.' });
      return;
    }

    try {
      const payload = {
        size: crud.formData.size.trim(),
        sortOrder: parseInt(String(crud.formData.sortOrder), 10) || 0,
        raceTypeId: crud.formData.raceTypeId ? parseInt(String(crud.formData.raceTypeId), 10) : null,
      };

      if (crud.editingEntity) {
        await updateSize.mutateAsync({ id: crud.editingEntity.id, data: payload });
        showSuccess('Успешно ажурирано', 'Големината е успешно ажурирана.');
      } else {
        await createSize.mutateAsync(payload);
        showSuccess('Успешно креирано', 'Нова големина е успешно додадена.');
      }

      crud.resetDialog();
    } catch (error) {
      showError(error, 'големината');
    }
  };

  const addDefaultSizes = async () => {
    const defaults = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
    try {
      for (let i = 0; i < defaults.length; i++) {
        await createSize.mutateAsync({
          size: defaults[i],
          sortOrder: i,
          raceTypeId: selectedRaceTypeId ? parseInt(selectedRaceTypeId, 10) : null,
        });
      }
      showSuccess('Успешно', 'Стандардните големини се додадени.');
    } catch (error) {
      showError(error, 'стандардни големини');
    }
  };

  return {
    isDialogOpen: crud.isDialogOpen, setIsDialogOpen: crud.setIsDialogOpen,
    editingSize: crud.editingEntity, setEditingSize: crud.setEditingEntity,
    deleteTarget: crud.deleteTarget, setDeleteTarget: crud.setDeleteTarget,
    formData: crud.formData, setFormData: crud.setFormData,
    handleEdit, handleDelete: crud.handleDelete, confirmDelete: crud.confirmDelete, handleSubmit,
    addDefaultSizes,
  };
};
